// extracted by mini-css-extract-plugin
export default {"rejectPendingConfirmDialog":"RejectPendingConfirmDialog-module_rejectPendingConfirmDialog__sSQ0Kl","actionButtons":"RejectPendingConfirmDialog-module_actionButtons__k2QKfv"};